import { DEMO_MEDIA_LIMIT, DEMO_MESSAGE_LIMIT, DEMO_TTL_MINUTES, } from './session.js';
const MINUTES_PER_DAY = 24 * 60;
/**
 * `unpaid` is what a wall is between "created" and "paid for": it exists, it has
 * its URLs, and its limits of zero mean the upload and message routes turn guests
 * away without anyone writing a second check for it. A day is long enough to
 * finish a checkout and short enough that cleanup collects the abandoned ones.
 */
export const PLAN_TERMS = {
    demo: {
        plan: 'demo',
        label: 'Demo',
        mediaLimit: DEMO_MEDIA_LIMIT,
        messageLimit: DEMO_MESSAGE_LIMIT,
        ttlMinutes: DEMO_TTL_MINUTES,
        allowVideo: false,
        forSale: false,
    },
    unpaid: {
        plan: 'unpaid',
        label: 'Not paid',
        mediaLimit: 0,
        messageLimit: 0,
        ttlMinutes: MINUTES_PER_DAY,
        allowVideo: false,
        forSale: false,
    },
    pro: {
        plan: 'pro',
        /**
         * Named for the thing bought rather than for a tier: one wall, in full, for
         * one event. "Pro" implied both a Free sibling and a monthly bill, and this
         * is neither - the landing page says "No subscription" out loud.
         */
        label: 'Full wall',
        /**
         * A number rather than "unlimited": the media lives on one box with one
         * volume, and an open-ended promise is one nobody can keep. 1500 is past
         * what any real event produces, and the landing page says the figure out
         * loud rather than leaving it to be discovered at the ceiling.
         */
        mediaLimit: 1500,
        messageLimit: null,
        ttlMinutes: 180 * MINUTES_PER_DAY,
        allowVideo: true,
        forSale: true,
    },
};
/** The plan a host is offered when their wall is waiting to be paid for. */
export const PURCHASABLE_PLAN = 'pro';
//# sourceMappingURL=plans.js.map